<template>
  <div>
    <el-row style="margin-bottom: 10px;">
      <el-col
        :span="funcData.parametros.exibirOrientacao ? 16 : 24"
        style="border-right: 1px solid #EEEEEE; padding-right: 25px; padding-left: 20px;"
      >
        <div>
          <FuncionalidadeHeader
            :info="false"
            :login="true"
            :titulo="funcData.parametros.textos.tituloNavegacao"
            :voltar="false"
          />

          <div
            v-if="error"
          >
            <ErrorAlerta
              style="margin-top: 0;"
              titulo="Usuário não elegível"
              texto="Usuário não consta na base de dados de beneficiários."
              :showBtn="false"
            />
          </div>

          <div
            v-else
          >
            <div
              v-if="funcData.parametros.textos.textoSubtitulo"
              v-html="funcData.parametros.textos.textoSubtitulo"
            />

            <div>
              <el-table
                :data="userData"
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="label"
                  width="*"
                />
                <el-table-column
                  prop="valor"
                  width="*"
                />
              </el-table>
            </div>
          </div>
          <el-col :span="12" class="button-default">
            <el-button
              class=""
              style="margin-top: 15px; max-width: 200px; min-height: 52px; background: #F60600; color: #FFF"
              @click="naoConfirma"
            >
              NÃO CONFIRMAR
            </el-button>
          </el-col>
          <el-col :span="12" class="button-default">
            <el-button
              :disabled="error"
              class=""
              style="margin-top: 15px; max-width: 200px; min-height: 52px; background: #1074FF; color: #FFF"
              @click="confirmarChamador"
            >
              CONFIRMAR CHAMADOR
            </el-button>
          </el-col>
        </div>
      </el-col>
      <el-col
        :span="8"
        v-if="funcData.parametros.exibirOrientacao"
      >
        <div style="padding: 20px;">
          <h3
            style=" padding: 30px 0;"
            v-if="funcData.parametros.textos.tituloObservacao"
            v-html="funcData.parametros.textos.tituloObservacao"
          />
          <div
            style="margin-top: 20px;"
            v-if="funcData.parametros.textos.textoObservacao"
            v-html="funcData.parametros.textos.textoObservacao"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ErrorAlerta from '@/components/Error/ErrorAlerta'
import { findDadosBeneficiarioFromChaveUnica } from '@mobilesaude/frontend_libs/helpers/usuario'
import { userBeneficiarioMap, userPerfilMap } from '@/views/141/elegibilidadeConstMap'

export default {
  name: 'Elegibilidade',
  components: { ErrorAlerta, FuncionalidadeHeader },
  data () {
    return {
      error: false,
      hiddenChar: '●'
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId', 'embedJson']),
    ...mapState('Login', ['usuarioPayload']),
    ...mapGetters('Login', ['user', 'token', 'beneficiarios', 'hasMultPerfil']),
    funcData () {
      return this.config.configuracaoAcesso.elegibilidade
    },
    userData () {
      if (!this.user) {
        return []
      }

      let usuario = findDadosBeneficiarioFromChaveUnica(this.user.chaveUnica, this.beneficiarios)

      let userMapLocal = [...userBeneficiarioMap]
      if (!usuario && this.hasMultPerfil) {
        userMapLocal = [...userPerfilMap]
        usuario = this.user
      }

      return userMapLocal.map((campo) => {
        const paths = campo.path.split('.')

        let valor = usuario

        try {
          paths.forEach((p) => {
            valor = valor[p]
          })
        } catch (ignored) {
          valor = null
        }

        if (valor) {
          if (valor.replace(/\s/g, '') === '') {
            valor = null
          }

          if (typeof campo.format === 'function') {
            valor = campo.format(valor)
          }

          valor = this.obfuscate(valor, campo.label)
        }

        if (!valor) {
          valor = '-'
        }

        return {
          label: campo.label,
          valor
        }
      })
    },
    redirect () {
      return this.$route.query.redirect || 0
    }
  },
  methods: {
    ...mapActions('Login', ['setLogin']),
    async init () {
      await this.elegibilidade()
    },
    async elegibilidade () {
      this.error = false
      if (!this.embedJson.atendimento) {
        this.error = true
        return
      }

      const payload = {
        ...this.embedJson.atendimento
      }

      const response = await this.apiAcesso.elegibilidade.elegibilidade({
        payload,
        headers: {
          Authorization: this.embedJson.atendimento.tokenAtendente
        },
        loading: true,
        handlerErrorIgnore: [401]
      })

      if (response.status) {
        this.setLogin(response)
        if (this.embedJson.atendimento.pularVerificacaoElegibilidade) {
          this.confirmarChamador()
        }
      } else {
        this.error = true
      }
    },
    confirmarChamador () {
      if (this.error) {
        return
      }
      this.sendElegibilidadeMessage({
        token: this.token,
        loginPayload: this.usuarioPayload
      })

      if (this.redirect) {
        const loader = this.$loading({
          lock: true,
          fullscreen: true,
          customClass: 'myloading'
        })
        setTimeout(() => {
          this.$router.replace({ path: `/${this.redirect}` })
          loader.close()
        }, 2000)
      }
    },
    sendElegibilidadeMessage (data) {
      const payload = {
        uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'ELEGIBILIDADE',
        data: { ...data },
        timestamp: Date.now()
      }
      window.parent.postMessage(payload, '*')
    },
    naoConfirma () {
      const payload = {
        uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'CLOSE_WIDGET',
        data: {},
        timestamp: Date.now()
      }
      window.parent.postMessage(payload, '*')
    },
    tableRowClassName ({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'odd-row-func141' : ''
    },
    obfuscate (valor, label) {
      if (!valor) return null

      switch (label) {
        case 'CPF':
          return this.obfuscateCpf(valor)
        case 'Telefone':
          return this.obfuscateTelefone(valor)
        case 'E-mail':
          return this.obfuscateEmail(valor)
        default:
          return valor
      }
    },
    obfuscateCpf (data) {
      if (!data) return null
      return data.slice(0, 3) + this.hiddenChar.repeat(6) + data.slice(9)
    },
    obfuscateTelefone (data) {
      if (!data) return null
      const prefix = data.slice(0, 2)
      const suffix = data.slice(2)
      return prefix + this.hiddenChar.repeat(suffix.length - 2) + suffix.slice(-2)
    },
    obfuscateEmail (data) {
      if (!data || data.indexOf('@') < 0) return null

      const domain = data.split('@')[1]
      const [username] = data.split('@')
      const obfuscatedUsername = username.slice(0, 3) + this.hiddenChar.repeat(username.length - 3)
      return obfuscatedUsername + '@' + domain
    }
  }
}
</script>

<style>
.el-table .odd-row-func141 {
  background: #E1ECF8;
}
</style>
